const easyReveal = {
    frames : [],
    init : ( selector, options ) => {
        options = options || { threshold : .95, repeat: false, class : 'revealed'  };
        selector = selector || '*[class*="reveal-"]';
        easyReveal.frames = document.querySelectorAll(selector);

        const observer = new IntersectionObserver( frames => {
            frames.forEach( (frame, idx) => {
                frame.target.classList.toggle('revealed', frame.isIntersecting);
                if( frame.isIntersecting ) { observer.unobserve( frame.target ) }
            } )
        }, { 
            threshold : .5,
            rootMargin : "0px"
        } ) 

        easyReveal.frames.forEach( frame => {
            if( !frame.classList.contains('revealed') ) {
                observer.observe( frame );
            }
        } )
    }
}

module.exports = easyReveal;